{
  "errors": {
    "yourRoleDoesNotAllowThisAction": "您的角色不允許您{action}",
    "yourRoleDoesNotAllowYouToPerformThisAction": "您的角色不允許您執行此動作",
    "mustHaveAtLeast8Characters": "至少須有 8 個字元",
    "mustContainUpperCaseAndLowerCase": "必須包含大寫與小寫字母",
    "mustContainAtLeastOneLetter": "必須包含至少一個字母",
    "mustContainAtLeastOneSpecialCharacter": "必須包含至少一個特殊字元",
    "mustContainAtLeastOneNumber": "必須包含至少一個數字"
  },
  "descriptions": {
    "allPermissionsAndFullControlOverAllAccounts": "擁有所有權限，並可完全控制所有帳戶。",
    "godRoleWithLessControl": "控制權限較少的 GOD 角色。",
    "allPermissionsAndFullControlOverTheOrganizationAccount": "擁有所有權限，並可完全控制組織帳戶。",
    "createEditDeleteAppointmentsWarehousesLoadTypesDocksAndUsersExceptOwners": "建立/編輯/刪除預約、倉庫、貨物類型、月台及使用者（擁有者除外）。",
    "createEditCancelAppointments": "建立/編輯/取消預約。",
    "editAppointmentStatusTagsAndSubscribers": "編輯預約狀態、標籤及訂閱者。",
    "viewOnlyNoCreateOrEditActionsAllowed": "僅限檢視。不允許建立或編輯動作。",
    "carrierAdministrator": "承運商管理員。",
    "carrierUser": "承運商使用者",
    "baseUserAccount": "基本使用者帳戶。",
    "warehouseDriverHasLimitedAccessToTheApplication": "倉庫司機，對應用程式的存取權限有限。"
  }
}
